import axios from 'axios';
import '../util/index.js';
import VM from '../main';
import vm from 'vue';
import { Loading } from 'element-ui';
import agreementDialog from '@/pages/quickRoutes/agreement/components/agreementDialog';
let userInfo = Util.getUserInfo();
const Http = axios.create({
  baseURL: Util.getGwRoot,
  timeout: 600000,
  withCredentials: true,
  headers: {
    // 'Access-Control-Allow-Credentials': true
    // 'Access-Control-Allow-Origin': '*'
  }
});
let requestNum = 0;
let loadingService = null;
let lastMessage = '';

// pending请求数量
// var requestNum = 0
Http.interceptors.request.use(
  config => {
    // 如果pending请求数量等于1，弹出loading, 防止重复弹出
    requestNum++;
    if (requestNum == 1 && !config.closeLoading) {
      loadingService = Loading.service({
        text: '正在努力加载中....',
        background: 'rgba(0, 0, 0, 0)'
      });
    }
    // if (requestNum === 1 && !config.hideLoading) {
    //   // vm.$zt.loading.show();
    // }
    // let userInfo = Util.getUserInfo();
    // config.headers.Token = userInfo && userInfo.token;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// 添加响应拦截器
var curMsg = '';
function alertMessageInfo(msg) {
  if (msg == curMsg) {
  } else {
    curMsg = msg;
    VM.$message({
      message: msg,
      onClose: function () {
        curMsg = '';
      }
    });
  }
}
Http.interceptors.response.use(
  res => {
    // 如果pending请求数量等于0，关闭loading
    --requestNum;
    if (requestNum === 0) {
      loadingService.close();
    }
    // 非网关请求
    if (res.config.url.includes('/pr/select/download')) {
      return res.data;
    }

    // 网关请求
    if (res.data.ok) {
      if (typeof res.data.result == 'number') {
        return res.data.result;
      }
      return res.data.result != null ? res.data.result : {};
    } else {
      const { code, message = '请求失败' } = res.data.error || {};

      // 处理协议校验
      if (code === 'BIZ_CHECK_ERROR') {
        const {
          code: extCode,
          hint: { agreementId, busiMobile, busiName },
          des
        } = res.data.error.extra;

        const { liabilityWhiteListInner, liabilityWhiteListOuter } = Constant.bizType;
        switch (extCode) {
          case liabilityWhiteListInner:
            agreementDialog.show({
              id: agreementId,
              principal: VM.$checkPower('a'),
              content: `请选择至少一种药师审方的规则，若均不勾选，将默认通过本平台药师进行审方，使用此功能前需联系公司负责人签署《平台药师审方服务使用承诺函》。如有疑问请联系业务经理：${
                busiName || ''
              } ${busiMobile || ''}`
            });
            break;
          case liabilityWhiteListOuter:
            agreementDialog.show({
              content:
                des ||
                `请选择至少一种药师审方的规则，若均不勾选，将默认通过本平台药师进行审方，使用此功能前需联系公司负责人签署《平台药师审方服务使用承诺函》。如有疑问请联系业务经理：${
                  busiName || ''
                } ${busiMobile || ''}`
            });
            break;
          default:
            agreementDialog.show({
              content: `请选择至少一种药师审方的规则，若均不勾选，将默认通过本平台药师进行审方，使用此功能前需联系公司负责人签署《平台药师审方服务使用承诺函》。如有疑问请联系业务经理：${
                busiName || ''
              } ${busiMobile || ''}`
            });
        }
      } else if (Constant.staffUpdateError[code]) {
        // 处理设置审方模式
        VM.$confirm(message, Constant.staffUpdateError[code].title, {
          confirmButtonText: '设置审方模式',
          showCancelButton: false,
          customClass: 'alert',
          center: true
        })
          .then(() => {
            VM.$router.push('/shopManagement');
          })
          .catch(() => {});
      } else if (code === 'LOGIN_REQUIRED' || code === 'INVALID_TOKEN') {
        // 处理登录 - 要先toast所以登录问题最后处理 似乎有点多余，在中间件中已经处理了这类错误
        VM.$message.error(`${message}`);
        setTimeout(() => VM.$router.replace({ name: 'Login' }), 500);
      } else if (/_ALERT$/.test(code)) {
        // 处理其他错误码
        Telescope.trackEvent({ trackId: `zywzpc-page-risk` });
        VM.$confirm(message.replace(';', ';<br/>'), '提示', {
          center: true,
          showCancelButton: false,
          dangerouslyUseHTMLString: true,
          customClass: 'alert',
          confirmButtonText: '我知道了'
        });
      } else {
        VM.$message.error(`${message}`);
      }

      return Promise.reject(res.data.error);
    }
  },
  error => {
    // 如果pending请求数量等于0，关闭loading
    --requestNum;
    if (requestNum === 0) {
      loadingService.close();
    }

    if (error.response && error.response.status === 401) {
      // 跳转到登录页
      // alertMessageInfo('无权限，请重新登陆');
      const { params } = error.config;
      if (params && params.apiConf) {
        // 存在接口配置项则拦截以下所有错误操作

        let { ishideError } = params.apiConf;

        if (ishideError) {
          return {};
        }
      }
      let err = error.response.data.error;
      if (err.message === lastMessage) {
        return Promise.reject(new Error(error));
      }
      lastMessage = err.message;
      VM.$message.error(`${err.message}`);
      setTimeout(() => {
        VM.$router.replace({ name: 'Login' }, () => {
          location.reload();
        });
      }, 300);
      clearTimeout(window.notificationTimer);
      // Util.removeCookie('userInfo'); // token过期后先把token清除
      return Promise.reject(new Error(error));
    } else {
      let err = error.response && error.response.data.error;
      Telescope.trackEvent({ trackId: 'zywzpc-request-error', custom: { err } });
      if (err && err.message) {
        // alertMessageInfo(err.message);
        VM.$message.error(`${err.message}`);
      } else {
        alertMessageInfo('网络异常');
      }
      return Promise.reject(error);
    }
  }
);

// 重写get，delete方法
let getFn = Http.get;
let delFn = Http.delete;

Http.get = function (url, data = {}, config = {}) {
  config.params = data;
  return getFn(url, config);
};
Http.delete = function (url, data = {}, config = {}) {
  config.data = data;
  return delFn(url, config);
};
/**
 * []请求
 * @param params  参数
 * @param operation     接口
 */
function customRequest(url, method, data) {
  let datatype = method.toLocaleLowerCase() === 'get' ? 'params' : 'data';
  return Http({
    url: url,
    method: method,
    [datatype]: data
  });
}
const chartRequest = axios.create({
  baseURL: Util.getChatServerAddr(),
  timeout: 600000
});

const cmsReauest = axios.create({
  withCredentials: false,
  baseURL: Util.getEnv() == 'qa' ? 'https://kit-static.91jkys.com/kit-server/fms-static/cms-qatest' : 'https://kit-static.91jkys.com/kit-server/fms-static/cms'
});
cmsReauest.interceptors.request.use(
  function (config) {
    config.url += '.json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

cmsReauest.interceptors.response.use(
  function (response) {
    // response.data = {
    //   result: response.data,
    //   message: '成功',
    //   ok: true
    // };
    return response.data;
  },
  function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export { Http, chartRequest, customRequest, cmsReauest };
